import { graphql } from "@/lib/gql/__generated__";

export const BasicCustomMailSettingI18nUpdate = graphql(/* GraphQL */ `
	mutation BasicCustomMailSettingI18nUpdate($input: BasicCustomMailSettingI18nInput!) {
		basicCustomMailSettingI18nUpdate(input: $input) {
			basicCustomMailSetting {
				# hotelID
				id
				mailFooterExternalLink
				forReservation {
					atCreated {
						text
					}
					atUpdated {
						text
					}
					atCanceled {
						text
					}
					atCheckInBefore_07days {
						text
						shouldSendEmail
					}
					atCheckInBefore_01days {
						text
						shouldSendEmail
					}
					atCheckInBefore_00days {
						text
						shouldSendEmail
					}
					atCheckOutAfter_01days {
						text
						shouldSendEmail
					}
					atRequest {
						text
					}
					atConfirmed {
						text
					}
					atDeclined {
						text
					}
				}
				forShopping {
					atCreated {
						text
					}
				}
			}
			userErrors
		}
	}
`);
